import React from "react";

import {get, map} from 'lodash';
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import * as Reports from "../../ReportComponents/reportStyles";
import BrandMultiSelect from "../ReportParams/BrandMultiSelect";
import DateRange, { DATE_RANGE_DEFAULT } from "../ReportParams/DateRange";
import DateType, { DATE_TYPE_DEFAULT } from "../ReportParams/DateType";
import RegionMultiSelect, { REGION_DEFAULT } from "../ReportParams/RegionMultiSelect";
import ServiceLevel, { SERVICE_LEVEL_DEFAULT } from "../ReportParams/ServiceLevel";
import { REPORT_PARAMS } from "../ReportParams/reportParams";
import * as ReportFilters from "./styles";


@inject("reportFormStore","deliveryStore", "userStore")
@observer
class ReportFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state  = {
            reportParams : this.props.reportParams
        }
    }

    componentDidMount(){
        const { deliveryStore, userStore, reportFormStore } = this.props;
        deliveryStore.loadRegions();
        if(userStore?.clientProfiles?.length > 0) {
          reportFormStore?.onFieldChange('client_profile_ids', userStore?.clientProfiles?.map(cp => cp.id))
        }
        else {
          userStore.getClientProfiles((res) => {
            if(res.ok) reportFormStore?.onFieldChange('client_profile_ids', res?.data?.map(cp => cp.id))
            else reportFormStore?.onFieldChange('client_profile_ids', [])
          });
        }
    }

    renderField = (name, param, getField) => {
        const {reportFormStore, deliveryStore, userStore} = this.props;
        const { regionList } = deliveryStore;
        const { isBrandsOwner, clientProfileOptions, clientSettings } = userStore;
        const serviceLevels = map(get(clientSettings, 'settings.service_filters')?.split(","), item => ({
          value: item,
          label: item.replaceAll("_", " ")
        }));

        switch (param) {
            case REPORT_PARAMS.REPORT_PARAM_DATE_RANGE:
                return <DateRange key={name} name={name} handleOnChange={reportFormStore.onFieldChange}
                                  currentValue={getField(name,DATE_RANGE_DEFAULT)}/>
            case REPORT_PARAMS.REPORT_PARAM_REGIONS:
                return <RegionMultiSelect key={name} name={name} handleOnChange={reportFormStore.onFieldChange}
                                       values={getField(name,REGION_DEFAULT)} regions={regionList}/>
            case REPORT_PARAMS.REPORT_PARAM_DATE_TYPE:
                return <DateType key={name} name={name} handleOnChange={reportFormStore.onFieldChange}
                                 currentValue={getField(name,DATE_TYPE_DEFAULT)}/>
            case REPORT_PARAMS.REPORT_PARAM_CLIENT_PROFILE_IDS:
              return (isBrandsOwner 
                ? <BrandMultiSelect 
                    key={name}
                    name={name} 
                    handleOnChange={reportFormStore.onFieldChange} 
                    clientProfileOptions={clientProfileOptions} 
                    profiles={getField(name, clientProfileOptions?.map(cp => cp.value))}
                  /> 
                : null)
            case REPORT_PARAMS.REPORT_PARAM_SERVICE_LEVELS:
              return (serviceLevels?.length > 0 
                ? <ServiceLevel 
                    key={name} 
                    name={name} 
                    handleOnChange={reportFormStore.onFieldChange}
                    values={getField(name, SERVICE_LEVEL_DEFAULT)} 
                    serviceLevels={serviceLevels}
                  />
                : null)
        }
    }

    render() {
        const {reportFormStore} = this.props;
        const { reportParams } = this.state;

        return (
            <ReportFilters.Container>
                <Reports.Flex style={{flexWrap: 'wrap'}}>
                    {
                        reportParams &&
                        Object.keys(reportParams).map((key, index) => {
                            const param = reportParams[key].type;
                            return this.renderField(key, param, reportFormStore.getField);

                        })}
                </Reports.Flex>
            </ReportFilters.Container>
        );
    }
}

export default withRouter(ReportFilter);